import { Calendar2 } from 'iconsax-reactjs';
import { memo } from 'react';
import { selectUiSidebarAppointmentOpen } from '@/store/features/ui/selectors';
import { toggleUISidebar } from '@/store/features/ui/slice';
import { SideBarContent } from '@/store/features/ui/types';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { StyledAppointmentToggleButton } from './styled';

const AppointmentToggleButton = () => {
  const isAppointmentOpen = useAppSelector(selectUiSidebarAppointmentOpen);

  const dispatch = useAppDispatch();

  const toggle = async () => {
    dispatch(
      toggleUISidebar({
        sidebar: SideBarContent.appointment,
      }),
    );
  };

  return (
    <StyledAppointmentToggleButton $active={isAppointmentOpen} onClick={toggle}>
      <Calendar2 variant={isAppointmentOpen ? "Bold" : "Outline"} />
    </StyledAppointmentToggleButton>
  );
};

export default memo(AppointmentToggleButton);
